<div class="main-content">
  <app-header [title]="'HEADER.TITLE_USER' | translate" [subtitle]="'HEADER.SUBTITLE_USER' | translate" />

  @if (hasMisalignedUsers) {
    <div class="row mt-5">
      <div class="col-12">
        <div class="warning-banner" [ngClass]="isLight ? 'light' : 'dark'">
          <div class="warning-icon">
            <app-icam-icon iconName="warning" [iconHeight]="'24px'" />
          </div>
          <span class="warning-text">{{ 'USER.MISALIGNED_WARNING' | translate: { count: misalignedUsersCount } }}</span>
          <div class="warning-button">
            <button class="btn button" (click)="showMisalignedUsers()">
              {{
                isMisalignedFilterActive
                  ? ('USER.SHOW_ALL_USERS' | translate)
                  : ('USER.SHOW_MISALIGNED_USERS' | translate)
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button class="welcome-message-button" (click)="toggleWelcomeMessageForm()" *appHasRole="['ADMIN']">
        {{ 'USER.EDIT_WELCOME_MESSAGE' | translate }}
      </button>
      <button class="welcome-message-button" [routerLink]="['/company-group']" *appHasRole="['ADMIN']">
        {{ 'USER.COMPANY_GROUPS' | translate }}
      </button>
      <button class="welcome-message-button" [routerLink]="['/legal-documents']" *appHasRole="['ADMIN']">
        {{ 'USER.LEGAL_DOCUMENTS' | translate }}
      </button>
      <button class="welcome-message-button" [routerLink]="['/machine-modules']" *appHasRole="['ADMIN']">
        {{ 'USER.MACHINE_MODULES' | translate }}
      </button>
      <button class="user-button" [routerLink]="['/user', 'new']" *appHasRole="['ADMIN']">
        {{ 'BANNER.CREATE_USER' | translate }}
      </button>
    </div>
  </div>

  @if (showWelcomeMessageForm) {
    <div class="welcome-message-modal" [@expandCollapse]>
      <div
        class="welcome-message-backdrop"
        (click)="onCloseWelcomeMessageForm()"
        (keydown.enter)="onCloseWelcomeMessageForm()"
        tabindex="0"
      ></div>
      <div class="welcome-message-container">
        <app-user-welcome-message-form (closeForm)="onCloseWelcomeMessageForm()"></app-user-welcome-message-form>
      </div>
    </div>
  }

  <div class="row mt-5">
    <div class="col-12">
      <app-icam-container [iconName]="'user'" iconHeight="24px">
        <div class="mb-4">
          <app-icam-tabs [tabs]="tabs" [selectedTabId]="selectedTab" (tabChange)="onTabChange($event)" />
        </div>

        @if (selectedTab === 0) {
          <app-table
            [allValues$]="users$"
            [type]="'users'"
            (selectedFilter)="onSelectedFilter($event)"
            [hasChart]="false"
            [filters$]="userFilter$"
            (selectedPage)="onUserPage($event)"
            [prevPage]="pagination[0].prev"
            [currentPage]="pagination[0].current"
            [nextPage]="pagination[0].next"
            [totalPages]="pagination[0].total"
            [hasKeywordFilter]="true"
            [useInlineKeywordFilter]="true"
            [keywordFilterName]="'keyword'"
            [keywordFilterPlaceholder]="'FILTER.SEARCH_USERS'"
            [initialFilters]="filters[0]"
          />
        }

        @if (selectedTab === 1) {
          <app-table
            [allValues$]="partners$"
            [type]="'partners'"
            (selectedFilter)="onSelectedFilter($event)"
            [hasChart]="false"
            [filters$]="userFilter$"
            (selectedPage)="onUserPage($event)"
            [prevPage]="pagination[1].prev"
            [currentPage]="pagination[1].current"
            [nextPage]="pagination[1].next"
            [totalPages]="pagination[1].total"
            [hasKeywordFilter]="true"
            [useInlineKeywordFilter]="true"
            [keywordFilterName]="'keyword'"
            [keywordFilterPlaceholder]="'FILTER.SEARCH_PARTNERS'"
            [initialFilters]="filters[1]"
          />
        }

        @if (selectedTab === 2) {
          <app-table
            [allValues$]="customerPartners$"
            [type]="'customer_partners'"
            (selectedFilter)="onSelectedFilter($event)"
            [hasChart]="false"
            [filters$]="userFilter$"
            (selectedPage)="onUserPage($event)"
            [prevPage]="pagination[2].prev"
            [currentPage]="pagination[2].current"
            [nextPage]="pagination[2].next"
            [totalPages]="pagination[2].total"
            [hasKeywordFilter]="true"
            [useInlineKeywordFilter]="true"
            [keywordFilterName]="'keyword'"
            [keywordFilterPlaceholder]="'FILTER.SEARCH_CUSTOMER_PARTNERS'"
            [initialFilters]="filters[2]"
          />
        }

        @if (selectedTab === 3) {
          <app-table
            [allValues$]="admins$"
            [type]="'users'"
            (selectedFilter)="onSelectedFilter($event)"
            [hasChart]="false"
            [filters$]="userFilter$"
            (selectedPage)="onUserPage($event)"
            [prevPage]="pagination[3].prev"
            [currentPage]="pagination[3].current"
            [nextPage]="pagination[3].next"
            [totalPages]="pagination[3].total"
            [hasKeywordFilter]="true"
            [useInlineKeywordFilter]="true"
            [keywordFilterName]="'keyword'"
            [keywordFilterPlaceholder]="'FILTER.SEARCH_USERS'"
            [initialFilters]="filters[3]"
          />
        }
      </app-icam-container>
    </div>
  </div>
</div>
